<template>
  <div>
    <label
      :for="id"
      class="inline-flex relative items-start mt-2 cursor-pointer"
    >
      <input
        type="checkbox"
        :checked="modelValue"
        @change="updateValue"
        :id="id"
        class="sr-only peer"
        :disabled="disabled"
      >
      <div
        class="w-9 h-5 flex-shrink-0 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-gray-700"
        :style="checkedBgColor && modelValue ? `background-color: ${checkedBgColor}` : ''"
      ></div>
      <span
        class="ml-3 text-sm font-medium text-gray-900 dark:text-gray-300"
        :class="showLabel ? '' : 'sr-only'"
      >
        {{ label }}
      </span>
    </label>
  </div>
</template>
<script>
export default {
  props: {
    showLabel: {
      type: Boolean,
      default: true,
    },
    label: {
      type: String,
      default: '',
    },
    modelValue: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    checkedBgColor: {
      type: String,
      default: null,
    },
  },
  data () {
    return {
      id: 'toggle-' + this.label + '-' + Math.random().toString(36).substring(2, 15),
    }
  },
  emits: ['update:modelValue'],
  methods: {
    updateValue () {
      console.log('updateValue', !this.modelValue)
      this.$emit('update:modelValue', !this.modelValue)
    },
  },
}
</script>
